import importCustomersApi from '@/api/post/customer/import-customers';
import FormWrapper from '@/components/form-wrapper/form-wrapper-component';
import { Row } from '@/components/grid/grid-component';
import Loader from '@/components/loader/loader-component';
import { useMutation } from '@/hooks/use-api';
import PropTypes from 'prop-types';
import ReactDOMServer from 'react-dom/server';
import Swal from 'sweetalert2';
import ImportCustomersModal from './import-customers-modal';

const swalDivStyle = {
  display: 'flex',
  justifyContent: 'flex-start',
  width: '90%',
  flexDirection: 'column',
};

const rowStyle = {
  marginLeft: '0px',
  marginRight: '0px',
  marginBottom: '40px',
  marginTop: '0px',
};

/**
 * Import customers wrapper
 * @param {object} root0 - props
 * @param {Function} root0.setOpenImportModal - Function to set the open state of the create modal
 * @param {Function} root0.refetch - Function to refetch the table data
 * @returns {JSX.Element}
 */
const ImportCustomersWrapper = ({ setOpenImportModal, refetch }) => {
  const [importCustomers, { loading: loadingImportCustomers }] =
    useMutation(importCustomersApi);

  const submitForm = (values) => {
    importCustomers(values).then((res) => {
      setOpenImportModal(false);
      Swal.fire({
        title: 'Import Results',
        html: ReactDOMServer.renderToString(
          <div style={swalDivStyle}>
            Customers:
            <ul>
              <li>{res.data.customers.added} new customers have been added.</li>
              <li>{res.data.customers.updated} customers have been updated.</li>
              <li>{res.data.customers.skipped} customers have been skipped.</li>
            </ul>
            Contact Persons:
            <ul>
              <li>
                {res.data.contactPersons.added} new contact persons have been
                added.
              </li>
              <li>
                {res.data.contactPersons.updated} contact persons have been
                updated.
              </li>
              <li>
                {res.data.contactPersons.skipped} contact persons have been
                skipped.
              </li>
            </ul>
            Operating Sites:
            <ul>
              <li>
                {res.data.operatingSites.added} new operating sites have been
                added.
              </li>
              <li>
                {res.data.operatingSites.updated} operating sites have been
                updated.
              </li>
              <li>
                {res.data.operatingSites.skipped} operating sites have been
                skipped.
              </li>
            </ul>
          </div>,
        ),
        showCloseButton: true,
        confirmButtonText: 'ok',
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.isConfirmed) {
          let query = '';
          const tablePreferences = localStorage.getItem('tablePreferences');
          if (tablePreferences) {
            const tableConfigs = JSON.parse(tablePreferences)['customer-list'];

            if (tableConfigs) {
              const { query: tableQuery } = tableConfigs.query;
              if (tableQuery) {
                query = tableQuery;
              }
            }
          }
          refetch(query.join('&'));
        }
      });
    });
  };

  return (
    <FormWrapper
      onSubmit={(values) => {
        submitForm(values);
      }}
    >
      {loadingImportCustomers ? (
        <Row style={rowStyle} justify="center">
          <Loader loading loadingText="...Loading" />
        </Row>
      ) : (
        <ImportCustomersModal
          onSubmit={(values) => {
            submitForm(values);
          }}
        />
      )}
    </FormWrapper>
  );
};

ImportCustomersWrapper.defaultProps = {
  setOpenImportModal: () => {},
  refetch: () => {},
};

ImportCustomersWrapper.propTypes = {
  setOpenImportModal: PropTypes.func,
  refetch: PropTypes.func,
};
export default ImportCustomersWrapper;
